import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';
import { cjsHook } from './../cjsObjects/cjsHook';

export class cjsDnD extends cjsItem {
  _thrown;
  _hooks;

  constructor(obj) {
    super(obj);
    this.thrown = false;
  }

  _checkHook(obj) {
    if (
      typeof this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty !== 'object' ||
      this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty === null
    )
      throw 'Brakuje gałęzi otherProperty dla grupy: ' + obj.idGroup + ' i elementu: ' + obj.idItem;
    if (
      typeof this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty.hooks !== 'object' ||
      typeof this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty.hooks === null
    )
      throw 'Brakuje konfiguracji HOOKS dla grupy: ' + obj.idGroup + ' i elementu: ' + obj.idItem;
    if (!Array.isArray(this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty.hooks.items))
      throw 'Brakuje konfiguracji kotwic dla grupy: ' + obj.idGroup + ' i elementu: ' + obj.idItem;

    let exists = false;
    this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty.hooks.items.forEach(function(hook) {
      exists = hook.id === obj.idHook ? true : exists;
    });
    return exists;
  }

  _setPropertyHook(i) {
    let tmp = _.cloneDeep(this.otherProperty.hooks),
      tmp1 = _.cloneDeep(this.otherProperty.hooks.items[i]);

    delete tmp.items;
    delete tmp1.id;

    return _.merge(tmp, tmp1);
  }

  create() {
    this.arrangeItems('hooks');

    if (this.autoFit === true) {
      let mX = false,
        mY = false,
        iW = false,
        iH = false;
      for (let i in this.hooks) {
        if (mX === false || mX < this.hooks[i].x) {
          mX = this.hooks[i].x;
          iW = this.hooks[i].width + this.hooks[i].margin.right;
        }
        if (mY === false || mY < this.hooks[i].y) {
          mY = this.hooks[i].y;
          iH = this.hooks[i].height + this.hooks[i].margin.bottom;
        }
      }

      this.pos.width = fJS.isNumeric(this.pos.width) ? this.pos.width : mX + iW + this.padding.right;
      this.pos.height = fJS.isNumeric(this.pos.height) ? this.pos.height : mY + iH + this.padding.bottom;
    }

    super.create();

    for (let i in this.hooks) {
      this._container.addChild(this.hooks[i]._container);
    }
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    /*    console.log(sets);
         console.log(layoutGroup);
         console.log(layoutItem);
         console.log(rules);*/

    if (typeof rules === 'object' && rules !== null && Array.isArray(rules.correct) && rules.correct.length > 0) {
      for (let i = 0; i < rules.correct.length; i++) {
        if (typeof rules.correct[i].idHook === 'string' && !this._checkHook(rules.correct[i]))
          throw 'Nie istnieje kotwica: ' +
            rules.correct[i].idHook +
            ' w grupie: ' +
            rules.correct[i].idGroup +
            ' w elemencie: ' +
            rules.correct[i].idItem;
      }
    }

    super.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);
    this.otherProperty.hideInTarget = this.otherProperty.hideInTarget === true ? true : false;
    this.otherProperty.checkCorrectInRealTime = this.otherProperty.checkCorrectInRealTime === true ? true : false;

    if (typeof this.otherProperty.hooks === 'object' && this.otherProperty.hooks !== null) {
      if (typeof this.hooks !== 'object' || this.hooks === null) this.hooks = {};

      if (!Array.isArray(this.otherProperty.hooks.items)) return;
      for (let i = 0; i < this.otherProperty.hooks.items.length; i++) {
        let layout = this._setPropertyHook(i),
          idx = Object.keys(this.hooks).length;
        this.hooks[this.otherProperty.hooks.items[i].id] = new cjsHook([
          _.cloneDeep(this.otherProperty.hooks.items[i]),
          this._stage,
        ]);
        this.hooks[this.otherProperty.hooks.items[i].id]._idx = idx;
        this.hooks[this.otherProperty.hooks.items[i].id].setLayout(
          'background',
          false,
          this.otherProperty.hooks,
          layout,
          false
        );
        this.hooks[this.otherProperty.hooks.items[i].id].setLayout(
          'positions',
          false,
          this.otherProperty.hooks,
          layout,
          false
        );
        this.hooks[this.otherProperty.hooks.items[i].id].setLayout(
          'shadow',
          false,
          this.otherProperty.hooks,
          layout,
          false
        );

        //    this.hooks[this.otherProperty.hooks.items[i].id].offset = null;
        if (
          this.hooks[this.otherProperty.hooks.items[i].id].layout.positions &&
          fJS.isNumeric(this.hooks[this.otherProperty.hooks.items[i].id].layout.positions.columns) &&
          this.hooks[this.otherProperty.hooks.items[i].id].layout.positions.columns > 0
        ) {
          this.cols = this.hooks[this.otherProperty.hooks.items[i].id].layout.positions.columns;
          delete this.hooks[this.otherProperty.hooks.items[i].id].layout.positions.columns;
        }
        if (
          this.hooks[this.otherProperty.hooks.items[i].id].layout.positions &&
          fJS.isNumeric(this.hooks[this.otherProperty.hooks.items[i].id].layout.positions.rows) &&
          this.hooks[this.otherProperty.hooks.items[i].id].layout.positions.rows > 0
        ) {
          this.rows = this.hooks[this.otherProperty.hooks.items[i].id].layout.positions.rows;
          delete this.hooks[this.otherProperty.hooks.items[i].id].layout.positions.rows;
        }

        // PADDINGI
        this.hooks[this.otherProperty.hooks.items[i].id].setMargin('padding', false, false, layout, false);

        if (!this.hooks[this.otherProperty.hooks.items[i].id].isAbsolute()) {
          // MARGINESY
          this.hooks[this.otherProperty.hooks.items[i].id].setMargin('margin', false, false, layout, false);

          //     this.hooks[this.otherProperty.hooks.items[i].id].offset = {};
        }

        this.hooks[this.otherProperty.hooks.items[i].id].create();
      }
    }
  }

  stageMouseDown(e, data) {
    console.log(this.id + ' cjsDnD: DOWN');

    let engine = data.engine,
      stage = data.cjsStage;

    stage.resetCheckStatus();
    if (stage.mousedown === true || engine.block === true) {
      e.stopPropagation();
      return false;
    }
    engine._mousedown = true;
    stage.mousedown = true;
    engine.container.parent.setChildIndex(engine.container, engine.container.parent.getNumChildren() - 1);

    for (let i = 0; i < stage.stage.children.length; i++) {
      if (engine.container.parent == stage.stage.children[i]) {
        stage.stage.setChildIndex(engine.container.parent, stage.stage.getNumChildren() - 1);
        break;
      }
    }

    engine._stageXY = new createjs.Point(Math.floor(e.stageX - stage.offset.x), Math.floor(e.stageY - stage.offset.y));
    engine._mouseLocal = false;

    if (stage._stage._listeners['pressmove'] === undefined) {
      stage.listener.pm = stage._stage.on('pressmove', engine._stageMouseMove, null, false, {
        engine: engine,
        cjsStage: stage,
      });
    }

    e.stopPropagation();
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown !== true || engine._mousedown !== true) {
      e.stopPropagation();
      return false;
    }
    if (engine._mouseLocal === false) engine._mouseLocal = { x: e.localX, y: e.localY };

    engine.x += e.localX - engine._mouseLocal.x;
    engine.y += e.localY - engine._mouseLocal.y;

    engine._mouseLocal = { x: e.localX, y: e.localY };

    if (engine.thrown !== false && typeof engine.thrown.idHook === 'string') {
      stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].isBusy = false;
      if (stage.config.isDev === true)
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].container.alpha = 1;
    }
    if (fJS.isNumeric(engine.aid) === false) {
      engine.thrown = engine._intersect(engine.inLine() === true);
    } else {
      engine.thrown = engine._intersectRotate();
    }
  }

  _intersectRotate(offBusy) {
    let t = [],
      width = this.width,
      height = this.height,
      p1 = this.container.localToGlobal(0, 0),
      p = this._getTransPoints({
        regX: this.container.regX,
        regY: this.container.regY,
        width: width,
        height: height,
        rotation: this.container.rotation,
      });

    for (let gr in this._stage.groups) {
      let group = this._stage.groups[gr];
      if (this._stage.config.isDev === true) group.container.alpha = 1;
      if (gr === this.idGroup) continue;

      let p2 = group.container.localToGlobal(0, 0);
      let w1 = p2.x + p.A.x,
        w2 = p2.x + group.width + p.A.x,
        h1 = p2.y + p.A.y,
        h2 = p2.y + group.height + p.A.y;
      /*
             console.log('w1: ' + w1 + ' w2: ' + w2 + ' h1: ' + h1 + ' h2: ' + h2);

             console.log('A: ' + (p1.x + p.A.x) + ' ' + (p1.y + p.A.y) );
             console.log('B: ' + (p1.x + p.B.x) + ' ' + (p1.y + p.B.y) );
             console.log('C: ' + (p1.x + p.C.x) + ' ' + (p1.y + p.C.y) );
             console.log('D: ' + (p1.x + p.D.x) + ' ' + (p1.y + p.D.y) ); */

      if (
        (p1.x + p.A.x >= w1 && p1.x + p.A.x <= w2 && p1.y + p.A.y >= h1 && p1.y + p.A.y <= h2) ||
        (p1.x + p.B.x >= w1 && p1.x + p.B.x <= w2 && p1.y + p.B.y >= h1 && p1.y + p.B.y <= h2) ||
        (p1.x + p.C.x >= w1 && p1.x + p.C.x <= w2 && p1.y + p.C.y >= h1 && p1.y + p.C.y <= h2) ||
        (p1.x + p.D.x >= w1 && p1.x + p.D.x <= w2 && p1.y + p.D.y >= h1 && p1.y + p.D.y <= h2)
      ) {
        t.push(gr);
        //    if (this._stage.config.isDev === true) group.container.alpha = 0.5;
      }
    }

    if (t.length > 0) {
      let gr = -1,
        it = -1;
      for (let i = 0; i < t.length; i++) {
        let tar = this._stage.groups[t[i]],
          d = tar.container.globalToLocal(this._stage.stage.mouseX, this._stage.stage.mouseY);
        if (tar.container.hitTest(d.x, d.y)) {
          gr = t[i];
        }
      }
      gr = typeof gr === 'string' ? gr : t[0];

      for (let i in this._stage.groups[gr].items) {
        let p2 = this._stage.groups[gr].items[i].container.localToGlobal(0, 0);
        let w1 = p2.x + p.A.x,
          w2 = p2.x + this._stage.groups[gr].items[i].width + p.A.x,
          h1 = p2.y + p.A.y,
          h2 = p2.y + this._stage.groups[gr].items[i].height + p.A.y;
        if (
          (p1.x + p.A.x >= w1 && p1.x + p.A.x <= w2 && p1.y + p.A.y >= h1 && p1.y + p.A.y <= h2) ||
          (p1.x + p.B.x >= w1 && p1.x + p.B.x <= w2 && p1.y + p.B.y >= h1 && p1.y + p.B.y <= h2) ||
          (p1.x + p.C.x >= w1 && p1.x + p.C.x <= w2 && p1.y + p.C.y >= h1 && p1.y + p.C.y <= h2) ||
          (p1.x + p.D.x >= w1 && p1.x + p.D.x <= w2 && p1.y + p.D.y >= h1 && p1.y + p.D.y <= h2)
        ) {
          it = i;
          //    if (this._stage.config.isDev === true) group.container.alpha = 0.5;
        }
      }

      if (it === -1) return false;

      let item = this._stage.groups[gr].items[it];

      if (item.hooks === undefined) {
        if (this._stage.config.isDev === true) item.container.alpha = 0.1;
        return { idGroup: gr, idItem: it };
      } else {
        if (this.thrown !== false && typeof this.thrown.idHook === 'string') {
          this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks[this.thrown.idHook].isBusy = false;
        }
        let hooks = [];

        for (let i in this._stage.groups[gr].items[it].hooks) {
          let p2 = this._stage.groups[gr].items[it].hooks[i].container.localToGlobal(0, 0);
          let w1 = p2.x + p.A.x,
            w2 = p2.x + this._stage.groups[gr].items[it].hooks[i].width + p.A.x,
            h1 = p2.y + p.A.y,
            h2 = p2.y + this._stage.groups[gr].items[it].hooks[i].height + p.A.y;
          if (
            (p1.x + p.A.x >= w1 && p1.x + p.A.x <= w2 && p1.y + p.A.y >= h1 && p1.y + p.A.y <= h2) ||
            (p1.x + p.B.x >= w1 && p1.x + p.B.x <= w2 && p1.y + p.B.y >= h1 && p1.y + p.B.y <= h2) ||
            (p1.x + p.C.x >= w1 && p1.x + p.C.x <= w2 && p1.y + p.C.y >= h1 && p1.y + p.C.y <= h2) ||
            (p1.x + p.D.x >= w1 && p1.x + p.D.x <= w2 && p1.y + p.D.y >= h1 && p1.y + p.D.y <= h2)
          ) {
            hooks.push(i);
            //    if (this._stage.config.isDev === true) group.container.alpha = 0.5;
          }
        }

        if (hooks.length > 0) {
          let h = -1;

          for (let i = 0; i < hooks.length; i++) {
            let hook = this._stage.groups[gr].items[it].hooks[hooks[i]],
              d = hook.container.globalToLocal(this._stage.stage.mouseX, this._stage.stage.mouseY);

            if (!hook.isBusy && hook.container.hitTest(d.x, d.y)) {
              h = hooks[i];
            }
          }

          h = typeof h === 'string' ? h : hooks[0];
          if (h === -1) return false;
          //   let h = hooks[0];
          if (this._stage.groups[gr].items[it].hooks[h].isBusy && offBusy !== true) return false;
          if (this._stage.config.isDev === true) this._stage.groups[gr].items[it].hooks[h].container.alpha = 0.1;
          return { idGroup: gr, idItem: it, idHook: h };
        }
      }
    }

    return false;
  }

  _checkCollision(c1, c2) {
    let w = 0,
      h = 0;
    // I:
    if (c1.p.x < c2.p.x && c2.p.x < c1.p.x + c1.w && c1.p.y < c2.p.y && c2.p.y < c1.p.y + c1.h) {
      w = c2.w < c1.w - (c2.p.x - c1.p.x) ? c2.w : c1.w - (c2.p.x - c1.p.x);
      h = c2.h < c1.h - (c2.p.y - c1.p.y) ? c2.h : c1.h - (c2.p.y - c1.p.y);
      //     console.log('I');
      return w * h;
    }
    // II:
    else if (c1.p.x < c2.p.x && c2.p.x < c1.p.x + c1.w && c2.p.y < c1.p.y && c2.p.y + c2.h > c1.p.y) {
      w = c2.w < c1.w - (c2.p.x - c1.p.x) ? c2.w : c1.w - (c2.p.x - c1.p.x);
      h = c1.h < c2.h - (c1.p.y - c2.p.y) ? c1.h : c2.h - (c1.p.y - c2.p.y);
      //     console.log('II');
      return w * h;
    }
    // III:
    else if (c1.p.x > c2.p.x && c1.p.x < c2.p.x + c2.w && c1.p.y > c2.p.y && c1.p.y < c2.p.y + c2.h) {
      w = c1.w < c2.p.x + c2.w - c1.p.x ? c1.w : c2.p.x + c2.w - c1.p.x;
      h = c1.h < c2.p.y + c2.h - c1.p.y ? c1.h : c2.p.y + c2.h - c1.p.y;
      //     console.log('III');
      return w * h;
    }
    // IV:
    else if (c1.p.x > c2.p.x && c1.p.x < c2.p.x + c2.w && c1.p.y < c2.p.y && c2.p.y < c1.p.y + c1.h) {
      w = c1.w < c2.p.x + c2.w - c1.p.x ? c1.w : c2.p.x + c2.w - c1.p.x;
      h = c2.h < c1.p.y + c1.h - c2.p.y ? c2.h : c1.p.y + c1.h - c2.p.y;
      //     console.log('IV');
      return w * h;
    }
    return w * h;
  }

  _intersect(offBusy) {
    let t = [],
      width = this.container.width,
      height = this.container.height,
      // punkt engine na stage (+offset)
      pt = this.container.parent.localToGlobal(this.container.x, this.container.y);

    for (let gr in this._stage.groups) {
      if (gr === this.idGroup) continue;

      let p1 = this._checkCollision(
        { p: pt, w: width, h: height },
        {
          p: {
            x: this._stage.groups[gr].x + this._stage.offset.x,
            y: this._stage.groups[gr].y + this._stage.offset.y,
          },
          w: this._stage.groups[gr].width,
          h: this._stage.groups[gr].height,
        }
      );

      if (p1 === 0) continue;
      let push = true;
      if (typeof this.otherProperty === 'object' && Array.isArray(this.otherProperty.exclusionGroups)) {
        for (let e = 0; e < this.otherProperty.exclusionGroups.length; e++) {
          if (
            this.otherProperty.exclusionGroups[e].indexOf(this.idGroup) !== -1 &&
            this.otherProperty.exclusionGroups[e].indexOf(gr) !== -1
          ) {
            push = false;
          }
        }
      }
      if (push === true) t.push(gr);
    }

    if (t.length === 0) return false;
    //         console.log(t);
    let gr = [];

    for (let i = 0; i < t.length; i++) {
      let group = this._stage.groups[t[i]];
      for (let j in group.items) {
        let item = group.items[j],
          It = group.container.localToGlobal(item.container.x, item.container.y),
          Iw = item.container.cacheMeasure.x2 - item.container.cacheMeasure.x1,
          Ih = item.container.cacheMeasure.y2 - item.container.cacheMeasure.y1,
          p1 = this._checkCollision({ p: pt, w: width, h: height }, { p: It, w: Iw, h: Ih });

        if (p1 === 0) continue;

        if (typeof item.hooks !== 'object' || item.hooks === null) {
          gr.push({
            idGroup: t[i],
            idItem: j,
            p: p1,
          });
        } else {
          for (let h in item.hooks) {
            let hook = item.hooks[h];
            if (hook.isBusy === true && offBusy !== true) continue;
            let ht = item.container.localToGlobal(hook.container.x, hook.container.y),
              ht2 = group.container.localToGlobal(ht.x, ht.y),
              hw = hook.width,
              hh = hook.height,
              p1 = this._checkCollision({ p: pt, w: width, h: height }, { p: ht, w: hw, h: hh });

            if (p1 === 0) continue;

            gr.push({
              idGroup: t[i],
              idItem: j,
              idHook: h,
              p: p1,
            });
          }
        }
      }
    }

    if (gr.length > 0) {
      if (this.thrown !== false && typeof this.thrown.idHook === 'string') {
        this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks[this.thrown.idHook].isBusy = false;
      }

      let max = _.maxBy(gr, 'p');
      delete max.p;
      return max;
    }
    return false;
  }

  _getTransPoints(e) {
    let obj = {},
      angle = e.rotation * (Math.PI / 180); //  => RADIAN

    let G = [
      [Math.cos(angle), Math.sin(angle), 0],
      [-Math.sin(angle), Math.cos(angle), 0],
      [
        e.regX * (1 - Math.cos(angle)) + e.regY * Math.sin(angle),
        -e.regX * Math.sin(angle) + e.regY * (1 - Math.cos(angle)),
        1,
      ],
    ];

    obj.A = this._getTPoint({ x: 0, y: 0 }, G);
    obj.B = this._getTPoint({ x: 0 + e.width, y: 0 }, G);
    obj.C = this._getTPoint({ x: 0 + e.width, y: 0 + e.height }, G);
    obj.D = this._getTPoint({ x: 0, y: 0 + e.height }, G);

    return obj;
  }

  _getTPoint(e, G) {
    let A = [],
      P = [
        [1, 0, 0],
        [0, 1, 0],
        [e.x, e.y, 1],
      ];
    for (let i = 0; i < P.length; i++) {
      A[i] = [];
      for (let j = 0; j < P.length; j++) {
        A[i][j] = 0;
        for (let k = 0; k < P.length; k++) {
          A[i][j] += P[i][k] * G[k][j];
        }
      }
    }

    return new createjs.Point(A[2][0], A[2][1]);
  }

  stageMouseUp(e, data) {
    console.log(this.id + ' cjsDnD: UP');

    let engine = data.engine;
    let stage = data.cjsStage;
    if (stage.mousedown !== true) {
      e.stopPropagation();
      return;
    }

    if (engine.thrown === false) {
      engine.dropItem();
    } else if (engine.thrown.idHook !== undefined) {
      let pt = engine.container.localToLocal(
        engine.regX,
        engine.regY,
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].container
      );

      engine.pos.x =
        engine.x -
        pt.x +
        engine.regX +
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].padding.left;
      engine.pos.y =
        engine.y -
        pt.y +
        engine.regY +
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].padding.top;
      stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].isBusy = true;
      stage.movesTo.push(engine);
    }
    if (engine.thrown !== false) {
      if (engine.otherProperty.hideInTarget === true) {
        engine.container.visible = false;
      }
      if (stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hideInTarget === true) {
        engine.container.visible = false;
      }
    }

    if (engine.thrown !== false) {
      stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');
    }

    if (engine.otherProperty.checkCorrectInRealTime === true) {
      console.log('checkCorrectInRealTime');
      let isCorrect = engine.checkInRealTime();
      if (isCorrect === true) {
        stage.sounds.play(engine.idGroup + '.' + engine.id + '.correct');
      } else if (isCorrect === false) {
        stage.sounds.play(engine.idGroup + '.' + engine.id + '.wrong');
        engine.dropItem(true);
      }
    }

    engine.stopMove(e);
    if (stage.autoCheckAllCorrect === true && cjsDnD.checkGameAction.call(this, stage, false) === true) {
      console.log('autoCheckAllCorrect');
      stage._mixins.$store.dispatch('checkGame');
    }
  }

  checkInRealTime() {
    if (this.thrown === false) return false;
    if (this.correct.length === 0) {
      this.dropItem(true);
      return false;
    }

    let isCorrect = false;
    for (let i in this.correct) {
      if (
        this.correct[i].idGroup === this.thrown.idGroup &&
        this.correct[i].idItem === this.thrown.idItem &&
        this.correct[i].idHook === this.thrown.idHook
      )
        isCorrect = true;
    }

    return isCorrect;
  }

  dropItem(droped) {
    if (this.thrown !== false) this.block = false;
    if (this._stage.removeInCorrects === true || droped === true) {
      if (this.thrown === false && this.pos.x === this.x && this.pos.y === this.y) return false;
      console.log('DROP: ' + this.idGroup + ' - ' + this.id);
      if (this.thrown !== false) {
        if (
          this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].otherProperty.hideInTarget === true ||
          this.otherProperty.hideInTarget === true
        ) {
          this.container.visible = true;
        }
        for (let i in this.thrown) {
          if (i === 'idHook') {
            this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks[this.thrown.idHook].isBusy = false;
          }
        }
        for (let i in this.thrown) {
          delete this.thrown[i];
        }
        this.thrown = false;
      }
      this.pos = _.cloneDeep(this.posStart);

      this._stage.movesTo.push(this);
    }
    return false;
  }

  stopMove(e) {
    this._stage.mousedown = false;
    this._mousedown = false;
    this._stage.stage.off('pressmove', this._stage.listener.pm);

    e.stopPropagation();
  }

  inLine() {
    return typeof this.otherProperty.inLine === 'boolean'
      ? this.otherProperty.inLine
      : this._stage.defConfig.sorting.inLine;
  }

  get thrown() {
    return this._thrown;
  }
  set thrown(v) {
    this._thrown = v;
  }
  get hooks() {
    return this._hooks;
  }
  set hooks(v) {
    this._hooks = v;
  }
}

cjsDnD.checkGameAction = function(stage, droped) {
  console.log('cjsDnD CHECK');

  let isCorrect = true,
    targets = {};

  // wyłapanie target'ów
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      item.isCorrect = false;

      if (item.block === false || item.thrown !== false) continue;
      if (typeof targets[gr] !== 'object' || targets[gr] === null) targets[gr] = {};
      targets[gr][i] = {
        items: [],
        correct: _.cloneDeep(item.correct),
        pickCorrect:
          typeof item.otherProperty === 'object' && fJS.isNumeric(item.otherProperty.pickCorrect)
            ? item.otherProperty.pickCorrect
            : false,
      };
    }
  }

  // SPRAWDZENIE SOURCE
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];

      if (item.block === true && item.thrown === false) continue;

      if (item.thrown === false && item.correct.length === 0) {
        item.isCorrect = true;
        continue;
      }

      if (item.thrown === false) {
        continue;
      }
      let idx = -1;
      for (let j = 0; j < targets[item.thrown.idGroup][item.thrown.idItem].items.length; j++) {
        let check = targets[item.thrown.idGroup][item.thrown.idItem].items[j];
        if (check.idItem !== item.id || check.idGroup !== item.idGroup || check.idHook !== item.thrown.idHook) continue;
        idx = j;
      }
      if (idx === -1)
        targets[item.thrown.idGroup][item.thrown.idItem].items.push({
          idItem: item.id,
          idGroup: item.idGroup,
          idHook: item.thrown.idHook,
          count: 1,
          idSources: new Array(item.id + (item.isClone === true ? '_' + item.clone.nrCopy : '')),
        });
      else {
        targets[item.thrown.idGroup][item.thrown.idItem].items[idx].count++;
        targets[item.thrown.idGroup][item.thrown.idItem].items[idx].idSources.push(
          item.id + (item.isClone === true ? '_' + item.clone.nrCopy : '')
        );
      }
    }
  }

  for (let gr in targets) {
    for (let i in targets[gr]) {
      targets[gr][i].isCorrects = 0;
      for (let j = 0; j < targets[gr][i].items.length; j++) {
        for (let k = 0; k < targets[gr][i].items[j].idSources.length; k++) {
          let it = stage.groups[targets[gr][i].items[j].idGroup].items[targets[gr][i].items[j].idSources[k]];
          for (let c1 = 0; c1 < targets[gr][i].correct.length; c1++) {
            if (targets[gr][i].correct[c1].idItem !== it.id) {
              continue;
            }
            if (fJS.isNumeric(targets[gr][i].correct[c1].count) !== true) targets[gr][i].correct[c1].count = 1;
            let count = 0;
            for (let c2 = 0; c2 < targets[gr][i].correct.length; c2++) {
              if (targets[gr][i].correct[c2].idGroup === it.idGroup && targets[gr][i].correct[c2].idItem === it.id) {
                count++;
              }
            }
            targets[gr][i].correct[c1].count = count;
          }
        }
      }
    }
  }

  // SPRAWDZANIE
  let removeFromTarget = [];
  for (let gr in targets) {
    for (let i in targets[gr]) {
      let item = stage.groups[gr].items[i];
      // gdy target powinien pozostać pusty
      if (targets[gr][i].items.length === 0 && targets[gr][i].correct.length === 0) {
        item.isCorrect = true;
        continue;
      }

      for (let j = 0; j < targets[gr][i].items.length; j++) {
        for (let k = 0; k < targets[gr][i].items[j].idSources.length; k++) {
          let it = stage.groups[targets[gr][i].items[j].idGroup].items[targets[gr][i].items[j].idSources[k]];
          if (it.correct.length === 0 && it.thrown !== false) {
            if (droped !== false) {
              if (
                stage.removeAllFromBadTarget === true &&
                removeFromTarget.findIndex((x) => x.idGroup === it.thrown.idGroup && x.idItem === it.thrown.idItem) ===
                  -1
              ) {
                removeFromTarget.push({ idGroup: it.thrown.idGroup, idItem: it.thrown.idItem });
              }
              if (stage.removeInCorrects === true) {
                it.dropItem();
              }
            }

            continue;
          }
          for (let c = 0; c < it.correct.length; c++) {
            if (it.isEqual(it.correct[c], it.thrown, true) === false) {
              continue;
            }

            targets[gr][i].isCorrects = 0;
            for (let c1 = 0; c1 < targets[gr][i].correct.length; c1++) {
              if (fJS.isNumeric(targets[gr][i].correct[c1].count) === false) {
                continue;
              }
              if (
                targets[gr][i].correct[c1].idGroup === it.idGroup &&
                targets[gr][i].correct[c1].idItem === it.id &&
                targets[gr][i].correct[c1].count > 0
              ) {
                it.isCorrect = true;
                targets[gr][i].correct[c1].count--;
              }

              if (targets[gr][i].correct[c1].count > 0) continue;
              targets[gr][i].isCorrects++;
            }

            if (
              (targets[gr][i].pickCorrect !== false && targets[gr][i].isCorrects === targets[gr][i].pickCorrect) ||
              targets[gr][i].isCorrects === targets[gr][i].correct.length
            )
              stage.groups[gr].items[i].isCorrect = true;
          }

          if (it.isCorrect === true && stage.correctBlock === true && droped !== false) {
            it.block = true;
            continue;
          }
          if (it.isCorrect === false && droped !== false) {
            if (
              stage.removeAllFromBadTarget === true &&
              removeFromTarget.findIndex((x) => x.idGroup === it.thrown.idGroup && x.idItem === it.thrown.idItem) === -1
            ) {
              removeFromTarget.push({ idGroup: it.thrown.idGroup, idItem: it.thrown.idItem });
            }
            if (stage.removeInCorrects === true) {
              it.dropItem();
            }
          }
        }
      }
    }
  }

  console.log(removeFromTarget);
  if (removeFromTarget.length > 0) {
    for (let i in removeFromTarget) {
      for (let gr1 in stage.groups) {
        if (gr1 == removeFromTarget[i].idGroup) {
          continue;
        }
        for (let i1 in stage.groups[gr1].items) {
          let item = stage.groups[gr1].items[i1];
          if (item.block === true) {
            continue;
          }
          if (
            item.thrown !== false &&
            item.thrown.idGroup == removeFromTarget[i].idGroup &&
            item.thrown.idItem == removeFromTarget[i].idItem
          ) {
            item.dropItem();
          }
        }
      }
    }
  }

  if (isCorrect === false) return false;

  for (let gr in targets) {
    for (let i in targets[gr]) {
      isCorrect =
        stage.groups[gr].items[i].isCorrect === false
          ? false
          : targets[gr][i].isCorrects !== targets[gr][i].items.length
          ? false
          : isCorrect;
    }
  }

  // console.log(targets);
  // console.log(stage.groups);

  return isCorrect;
};
